(function () {
    "use strict";

    angular
        .module("app")
        .factory("DocumentService", documentService);

    // ReSharper disable once InconsistentNaming
    function documentService($http, $q, WebAPIUrl, WebApiService) {

        var service = {
            getDocumentCategoryList: getDocumentCategoryList,
            uploadDocument: uploadDocument,
            getDocumentsList: getDocumentsList,
            deleteDocument: deleteDocument,
            getFileTypeConfigInfo: getFileTypeConfigInfo,
            downloadFile: downloadFile,
            changeDocumentFactory: changeDocumentFactory,
            removeDocumentFactory: removeDocumentFactory,
            openTempDocument: openTempDocument,
            getAssociatedPrototypes: getAssociatedPrototypes,
            savePrototypeAssociations: savePrototypeAssociations
        };

        return service;

        function getDocumentsList(projectId, projectLevelId) {
            return WebApiService.get("/api/Document/DocumentsList?projectId=" + projectId + "&projectLevelId=" + projectLevelId);
        }

        function getDocumentCategoryList(projectLevelId) {
            return WebApiService.get("/api/Document/DocumentCategoryList?ProjectLevelId=" + projectLevelId);
        }

        function uploadDocument(file, details, progress) {
            var url = "/api/Document/UploadDocument?ProjectId=" + details.ProjectId + "&ProjLevDocCategoryId=" + details.ProjLevDocCategoryId
                + "&factoryKey=" + details.FactoryKey + "&factoryName=" + details.FactoryName + "&FactoryGroupKey=" + details.FactoryGroupKey + "&FactoryGroupName=" + details.FactoryGroupName + "&isApproved=" + details.IsApproved;

            return WebApiService.postFile(url, file, true, progress);
        }

        function deleteDocument(documentId) {
            return WebApiService.get("/api/Document/DeleteDocument?DocumentId=" + documentId);
        }

        function getFileTypeConfigInfo(fileTypeId) {
            return WebApiService.get("/api/Document/FileTypeConfigInfo?FileTypeId=" + fileTypeId);
        }

        function downloadFile() {
            return WebApiService.get("/api/Document/DownloadFile");
        }

        function changeDocumentFactory(documentId, oldFactoryKey, newFactoryKey, newFactoryName, newFactoryGroupKey, newFactoryGroupName) {
            var data = {
                documentId: documentId,
                oldFactoryKey: oldFactoryKey,
                newFactoryKey: newFactoryKey,
                newFactoryName: newFactoryName,
                newFactoryGroupKey: newFactoryGroupKey,
                newFactoryGroupName: newFactoryGroupName
            };

            return WebApiService.postJson("/api/Document/ChangeDocumentFactory", data);
        }

        function removeDocumentFactory(documentId, factoryKey) {
            var data = {
                documentId: documentId,
                factoryKey: factoryKey
            };

            return WebApiService.postJson("/api/Document/RemoveDocumentFactory", data);
        }

        function openTempDocument(key, contentType, name) {
            window.open("/api/Document/TempDocument?key=" + key + "&contentType=" + contentType + "&name=" + name);
        }

        function getAssociatedPrototypes(documentId) {
            return WebApiService.get("/api/Document/AssociatedPrototypes?documentId=" + documentId);
        }

        function savePrototypeAssociations(documentId, prototypeSeasonalIds) {
            return WebApiService.postJson("/api/Document/SavePrototypeAssociations", { documentId: documentId, prototypeSeasonalIds: prototypeSeasonalIds });
        }
    }

})();
